import React from "react";
import { Link, useParams } from "react-router-dom";

import CGMStatusCardTemplate from "./CGMStatusCardTemplate";
import Button from "src/components/app/Button";
import { sendMessageToParent } from "src/helpers/common";
import { POST_MESSAGE_EVENTS } from "src/constants/common";

import CGMExpiredStatus from "src/assets/images/cgm/status/cgm-expired-status.png";
import useCgmHook from "src/hooks/useCgm.hook";

interface CGMBluetoothOffStatusCardProps {
  color: string;
  label: string;
  bgColor?: string;
}

const CGMBluetoothOffStatusCard: React.FC<CGMBluetoothOffStatusCardProps> = ({
  color,
  label,
  bgColor,
}) => {
  const params = useParams();
  const supportProgramKey = params["support-program-key"] ?? "";
  const { sensorInfo } = useCgmHook();

  const handleTurnOnBluetooth = () => {
    sendMessageToParent(POST_MESSAGE_EVENTS.TURN_ON_BLUETOOTH, {});
  };

  return (
    <CGMStatusCardTemplate
      image={CGMExpiredStatus}
      color={color}
      bgColor={bgColor}
      label={label}
      sensorStartDate={sensorInfo.startDate}
      sensorEndDate={sensorInfo.endDate}
      description={
        <div className="space-y-4">
          <p className="text-xs text-gray-600">
            Bluetooth is turned off on this phone. Turn it on so your CGM can
            connect. On some devices, the app will open Bluetooth or system
            settings.
          </p>
          <Button
            type="button"
            variant="contained"
            rounded="full"
            fullWidth
            onClick={handleTurnOnBluetooth}
          >
            Turn on Bluetooth
          </Button>
        </div>
      }
      bottomContent={
        <p className="text-sm text-gray-500 text-center">
          Take a look at your{" "}
          <Link
            to={`/app/${supportProgramKey}/insights-screen?tab=vitals&sub-tab=glucose`}
            className="text-[var(--app-primary)] font-semibold underline"
          >
            CGM Insights
          </Link>
        </p>
      }
    />
  );
};

export default CGMBluetoothOffStatusCard;
